import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Trash2, Plus, Minus, ShoppingBag, ArrowRight } from 'lucide-react';
import { useCart } from '../context/CartContext';
import './CartPage.css';

export default function CartPage() {
  const { items, removeItem, updateQuantity, subtotal, shippingCost, tax, total, clearCart } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) return (
    <div className="cart-page-empty container">
      <ShoppingBag size={80} />
      <h2>Your Cart is Empty</h2>
      <p>Looks like you haven't added any coffee yet!</p>
      <Link to="/shop" className="btn-gold">Browse Products</Link>
    </div>
  );

  return (
    <div className="cart-page container">
      <h1>Shopping Cart</h1>
      <div className="cart-layout">
        <div className="cart-items-full">
          <div className="cart-table-header">
            <span>Product</span><span>Price</span><span>Qty</span><span>Total</span><span></span>
          </div>
          {items.map(item => (
            <div key={item._id} className="cart-row">
              <div className="cart-product">
                <img src={item.thumbnail || 'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=100'} alt={item.name} />
                <div>
                  <Link to={`/product/${item._id}`}>{item.name}</Link>
                  {item.weight && <span>{item.weight.value}{item.weight.unit}</span>}
                </div>
              </div>
              <span className="cart-cell">CHF {item.price.toFixed(2)}</span>
              <div className="cart-cell qty-ctrl">
                <button onClick={() => updateQuantity(item._id, item.quantity - 1)}><Minus size={14} /></button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item._id, item.quantity + 1)} disabled={item.quantity >= item.stock}><Plus size={14} /></button>
              </div>
              <span className="cart-cell total-cell">CHF {(item.price * item.quantity).toFixed(2)}</span>
              <button className="remove-btn" onClick={() => removeItem(item._id)}><Trash2 size={16} /></button>
            </div>
          ))}
          <div className="cart-actions">
            <button className="btn-secondary" onClick={clearCart}>Clear Cart</button>
            <Link to="/shop" className="btn-secondary">Continue Shopping</Link>
          </div>
        </div>

        <div className="cart-totals">
          <h3>Order Summary</h3>
          <div className="tot-row"><span>Subtotal</span><span>CHF {subtotal.toFixed(2)}</span></div>
          <div className="tot-row"><span>Shipping</span><span>{shippingCost === 0 ? <span style={{color:'var(--success)'}}>Free</span> : `CHF ${shippingCost.toFixed(2)}`}</span></div>
          <div className="tot-row"><span>VAT (7.7%)</span><span>CHF {tax.toFixed(2)}</span></div>
          {subtotal < 50 && <p className="ship-hint">Add CHF {(50 - subtotal).toFixed(2)} more for free shipping</p>}
          <div className="tot-total"><span>Total</span><span>CHF {total.toFixed(2)}</span></div>
          <button className="btn-gold checkout-btn" onClick={() => navigate('/checkout')}>
            Proceed to Checkout <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
